/**
 * Massager (clinic) shared constants.
 * Per BA 4.2.1 はり・きゅう師情報編集_Change Acupuncturist Info_A2.
 * Reused by massagerDetailSchema, MassagerDetailModal, MassagerBulkSettingsModal.
 */

import { SERVICE_TYPE_A2 } from '@/constants/serviceType';

/** Default end date when 適用期間 has only start date (令和82年12月31日). */
export const MASSAGER_AVAILABLE_END_DATE_DEFAULT = '令和82年12月31日';

/** Max length: email in clinic massager detail (BA: 255). */
export const MASSAGER_DETAIL_EMAIL_MAX = 255;

/** Max length: login_id in clinic massager detail (BA: 100). */
export const MASSAGER_DETAIL_LOGIN_ID_MAX = 100;

/** Max length: password in clinic massager detail (BA: 100). */
export const MASSAGER_DETAIL_PASSWORD_MAX = 100;

/** GPS range options: value and label (BA: 150m, 300m, 450m). */
export const MASSAGER_GPS_RANGE_OPTIONS: { value: 1 | 2 | 3; label: string }[] = [
  { value: 1, label: '150m' },
  { value: 2, label: '300m' },
  { value: 3, label: '450m' },
];

/** Service type display labels: A2 = はり・きゅう師, R2 = マッサージ師 */
export function getDisplayTypeLabel(serviceType: string): string {
  return serviceType === SERVICE_TYPE_A2 ? 'はり・きゅう師' : 'マッサージ師';
}
